import { render } from "./CharlaReview.vue?vue&type=template&id=38896b02&scoped=true"
import script from "./CharlaReview.vue?vue&type=script&lang=js"
export * from "./CharlaReview.vue?vue&type=script&lang=js"

import "./CharlaReview.vue?vue&type=style&index=0&id=38896b02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38896b02"]])

export default __exports__